const { getElement, getElements } = window.BAO.Utils

export class DrawerQuickBuyGWP extends customElements.get('site-drawer') {
  constructor () {
    super()
    // Used for section rendering API
    this.sectionId = 'quick-buy-gwp'

    if (this.getAttribute('data-drawer-quick-buy-gwp-el') === 'bundle') {
      this.sectionId = 'quick-buy-bundles'
    }
  }

  static get observedAttributes () {
    return ['reinitialise']
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (name === 'reinitialise' && newValue === 'true') {
      this.addCartListeners()
    }
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    if (this.gwpHandler) {
      document.removeEventListener('addGWP', this.gwpHandler)
    }

    if (this.pushCartHandler) {
      window.BAO.eventBus.removeEventListener(
        window.BAO.EVENTS.PUSH_CART.CHANGED,
        this.pushCartHandler,
      )
    }
  }

  setupListeners () {
    super.setupListeners()

    this.pushCartHandler = this.addCartListeners.bind(this)
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.pushCartHandler,
    )

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleTriggerClick = (event) => this.handleTrigger(event)

    this.addCartListeners()
  }

  addCartListeners () {
    if (!this.gwpHandler) {
      this.gwpHandler = (e) => {
        this.handleTrigger(e.detail)
      }
      document.addEventListener('addGWP', this.gwpHandler)
    }

    this.triggers = getElements('[data-drawer-quick-buy-gwp-external-el="trigger"]')
    this.body = getElement('[data-drawer-quick-buy-gwp-el="body"]', { context: this })

    this.triggers.forEach(trigger => {
      this.listeners.remove(trigger, 'click', this.handleTriggerClick)
    })

    this.triggers.forEach(trigger => {
      this.listeners.add(trigger, 'click', this.handleTriggerClick)
    })
  }

  handleTrigger (detail) {
    if (!detail) return

    this.renderDrawerContent(detail)
  }

  async renderDrawerContent (detail) {
    const html = await this.sectionRenderer.fetchSingle(this.sectionId, detail.productUrl)

    const innerHtml = this.sectionRenderer.getInnerHtml(html)
    if (!html || !innerHtml) return

    const parser = new DOMParser()
    const doc = parser.parseFromString(innerHtml, 'text/html')

    // Try multiple selectors to find the form
    let target = doc.querySelector('#product-form-quick-buy-gwp')

    if (!target) {
      // Try looking for any form with data-product-form
      target = doc.querySelector('form[data-product-form]')
      console.info('GWP Drawer: Trying alternate selector, found?', !!target)
    }

    if (!target) {
      // Try looking for any form with data-quickbuy-form
      target = doc.querySelector('form[data-quickbuy-form]')
      console.info('GWP Drawer: Trying quickbuy selector, found?', !!target)
    }

    if (target) {
      const gwpProperty = doc.createElement('input')
      gwpProperty.type = 'hidden'
      gwpProperty.name = 'properties[_gwp]'
      gwpProperty.value = 'true'

      const campaignProperty = doc.createElement('input')
      campaignProperty.type = 'hidden'
      campaignProperty.name = 'properties[_gwp_campaign]'
      campaignProperty.value = detail.campaignId || ''

      const thresholdProperty = doc.createElement('input')
      thresholdProperty.type = 'hidden'
      thresholdProperty.name = 'properties[_threshold]'
      thresholdProperty.value = detail.threshold || ''

      const maxThresholdProperty = doc.createElement('input')
      maxThresholdProperty.type = 'hidden'
      maxThresholdProperty.name = 'properties[_max_threshold]'
      maxThresholdProperty.value = detail.maxThreshold || ''

      const hiddenFreeGift = doc.createElement('input')
      hiddenFreeGift.type = 'hidden'
      hiddenFreeGift.name = 'properties[_hiddenFreeGift]'
      hiddenFreeGift.value = 'true'

      target.appendChild(gwpProperty)
      target.appendChild(campaignProperty)
      target.appendChild(thresholdProperty)
      target.appendChild(maxThresholdProperty)
      target.appendChild(hiddenFreeGift)

      // Only add _hiddenFreeGiftCookieless if showRemoveButton is false
      if (!detail.showRemoveButton) {
        const hiddenFreeGiftCookieless = doc.createElement('input')
        hiddenFreeGiftCookieless.type = 'hidden'
        hiddenFreeGiftCookieless.name = 'properties[_hiddenFreeGiftCookieless]'
        hiddenFreeGiftCookieless.value = 'true'
        target.appendChild(hiddenFreeGiftCookieless)
      }

      // Add _gwp_auto_added if autoAddEnabled is true
      if (detail.autoAddEnabled) {
        const gwpAutoAdded = doc.createElement('input')
        gwpAutoAdded.type = 'hidden'
        gwpAutoAdded.name = 'properties[_gwp_auto_added]'
        gwpAutoAdded.value = 'true'
        target.appendChild(gwpAutoAdded)
      }

      if (detail.freeGiftStyling !== undefined && detail.freeGiftStyling !== null) {
        const freeGiftStyling = doc.createElement('input')
        freeGiftStyling.type = 'hidden'
        freeGiftStyling.name = 'properties[_freeGiftStyling]'
        freeGiftStyling.value = detail.freeGiftStyling || ''

        target.appendChild(freeGiftStyling)
      }
    }

    // Add custom price text to the price display if it exists
    if (detail.customPriceText) {
      const priceContainer = doc.querySelector('[data-gwp-price-container]')
      const customPriceElement = doc.querySelector('[data-product-gwp-price-custom]')

      if (priceContainer && customPriceElement) {
        // Show the price container
        priceContainer.removeAttribute('hidden')

        // Set the custom price text
        customPriceElement.textContent = detail.customPriceText
      }
    }

    const variantId = localStorage.getItem(`lastGWPVariant${detail.productId}`)

    this.updateBodyContent(doc.body.innerHTML, variantId)
    this.openDrawer()
  }

  openDrawer () {
    getElement('site-drawers')?.open(this.getAttribute('key'))
  }

  closeDrawer () {
    getElement('site-drawers')?.closeDrawer(this.getAttribute('key'))
  }

  updateBodyContent (content, variantId) {
    this.body.innerHTML = ''
    this.body.insertAdjacentHTML('beforeend', content)

    if (variantId) {
      const variantInput = this.querySelector(`input[data-variant-id="${variantId}"]`)
      variantInput?.click()
    }
  }

  /**
   * @returns {sectionRenderer} The BAO sectionRenderer class
   */
  get sectionRenderer () {
    return window.BAO.sectionRenderer
  }
}

customElements.define('drawer-quick-buy-gwp', DrawerQuickBuyGWP)
